<ng-container *ngrxLet="noPrizeContent$ as noPrizeContent">
    @if (noPrizeContent) {
        @if (noPrizeContent) {
            <ds-card [elevated]="dsComponents?.dsCardStatic?.elevated" [variant]="dsComponents?.dsCardStatic?.variant">
                <div class="achieved-np position-relative ph-container-bg-w-marker" [class.disabled]="isDisabled">
                    <div class="achieved-header">{{ noPrizeContent.title }}</div>
                    <div class="achieved-header-desc">{{ noPrizeContent.description }}</div>
                    <div class="achieved-np-bg">
                        <img [attr.src]="noPrizeContent.noPrizeImage?.src" />
                    </div>
                    <div class="achieved-np-btm-header">
                        {{ noPrizeContent.content }}
                    </div>
                    <div class="achieved-np-btm-header-desc">
                        {{ noPrizeContent.moreContent }}
                    </div>
                </div>
            </ds-card>
        }
    }
</ng-container>
